import { defineStore } from "pinia";


export const useUser = defineStore('user',{
    state(){
        return {
            userInfo : {},
            companys:[],
            companyInfo:{},
            menus: []
        }
    },
    actions: {
        updateInfo(data){
            this.userInfo = {
                ...this.userInfo,
                ...data
            }
        },
    }
})